import VisibilitySensor from 'react-visibility-sensor';
import { useEffect, useState } from 'react';
import ProductCard from './ProductCard';
import { useLocation } from 'react-router';
import Loading from '../Common/Loading';

const ProductsWrapper = (props) => {
  const location = useLocation();
  const [metadata, setMetadata] = useState([]);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const pdata = props.data;

  const TableComponent = props.TableComponent;
  const urlReturn = props.urlReturn ?? location.pathname + location.search;

  useEffect(() => {
    setIsLoading(false);
    setMetadata(pdata.metadata);
    if (pdata.update)
      pdata.data.forEach((d) => {
        const index = data.findIndex((e) => e.id === d.id);
        setData(index !== -1 ? [d, ...data.slice(0, index), ...data.slice(index + 1)] : [d, ...data]);
      });
    else setData(pdata.new ? pdata.data : [...data, ...pdata.data]);

    // eslint-disable-next-line
  }, [pdata]);

  const handleVisibilitySensor = (isVisible) => {
    if (isVisible && !isLoading && metadata.next) {
      setIsLoading(true);
      props.loadPage(metadata.page + 1);
    }
  };

  return (
    <>
      {data &&
        data.map((d, k) => (
          <ProductCard product={d} key={k} urlReturn={urlReturn}>
            <TableComponent product={d} />
          </ProductCard>
        ))}
      {metadata && metadata.next && metadata.page && (
        <VisibilitySensor onChange={handleVisibilitySensor}>
          <Loading />
        </VisibilitySensor>
      )}
    </>
  );
};
export default ProductsWrapper;
